import Vue from 'vue';
import VueI18n from 'vue-i18n';
import webStorage from '@/libs/webStorage';
import enMessage from './locales/en.json';
import vnMessage from './locales/vi.json';
import _ from 'lodash';

Vue.use(VueI18n);

const localeDefault = 'vi';
const localeCurrent = webStorage.get('LOCALE');

function checkValidLocale(locale) {
  const index = _.findIndex(['vi', 'en'], function (o) {
    return o === locale;
  });

  if (index != -1) {
    return true;
  }
  webStorage.set("LOCALE", localeDefault);
  return false;
};

const i18n = new VueI18n({
  lazy: true,
  locale: checkValidLocale(localeCurrent) ? localeCurrent : localeDefault,
  messages: {
    en: enMessage,
    vi: vnMessage,
  }
});

export default i18n;